// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { annotationPlugin } from '@atlaskit/editor-plugin-annotation';
export type {
	AnnotationPlugin,
	AnnotationPluginOptions,
	AnnotationInfo,
	AnnotationProviders,
	AnnotationState,
	AnnotationTypeProvider,
	InlineCommentAnnotationProvider,
	InlineCommentCreateComponentProps,
	InlineCommentInputMethod,
	InlineCommentState,
	InlineCommentViewComponentProps,
	TargetType,
	InlineCommentMap,
	InlineCommentPluginState,
	InlineCommentPluginOptions,
	InlineCommentAction,
} from '@atlaskit/editor-plugin-annotation';
